export const SharedDocumentLogPermissions = {
    GetAllShareDocumentLog: {
    permissionsId: 'a5b07a12-ebfd-41ba-7951-08dcaf947ea8',
    permissionsName: 'Get All Share Document Log',
    description: null,
    componentsId: null,
    components: null,
  },
};
